<!-- Header Nav bar end -->
<header class="header-fixed" [ngClass]="{ 'sticky': isSticky }">
    <nav class="navbar navbar-expand-lg navbar-dark landing-navbar">
        <a class="navbar-brand" href="/"><img [src]="logoUrl" alt="Logo"
                class="header-image-logo"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link" (click)="scroll(works)">How It Works</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scroll(program)">Program</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scroll(projects)">Projects</a>
                </li>
            </ul>
            <div class="right-nav-links my-2 my-lg-0">
                <div><a class="button-size btn-bg-purple rounded-bottom-right"
                        href="https://join.skype.com/gy9Zg7vFQAsn" target="_blank"><i class="fa fa-skype mr-1"
                            aria-hidden="true"></i>Join Us</a></div>
                <!-- <div class="cart-link ml-3"><a><i class="ft-shopping-cart"></i></a></div>
        <div class="cart-search ml-3"><a><i class="ft-search"></i></a></div> -->
            </div>
        </div>
    </nav>
</header>
<!-- Header Nav bar end -->

<!-- Start Slider First Section  -->
<div class="slider-carousel-info">
    <div id="carouselExampleCaptions1" class="carousel slide carousel-fade1" data-ride="carousel1">
        <!-- <ol class="carousel-indicators">
            <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
        </ol> -->
        <div class="carousel-inner">
            <div class="carousel-item active" style="background-image: url(assets/img/bgn-slide-01.jpg);">
                <div class="row mob-flex-direction m-0">
                        <!-- <img src="assets/img/img-slider-01.png" class="d-block w-100" alt="..."> -->
                    <div class="col-lg-6 col-12 px-4 py-1 login-form">
                        <h2  class="font-weight-400 title">Welcome back,<br> please login to your account.</h2>
                        <ngb-alert type="light-danger" class="mb-2" *ngIf="isLoginFailed" (close)="isLoginFailed= false">
                            <p class="mb-0">Login failed!</p>
                        </ngb-alert>
                        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" id="form">
                            <div class="form-group">
                            <input type="email" formControlName="email" class="form-control" placeholder="email or phone" [ngClass]="{ 'is-invalid': loginFormSubmitted &&
                                lf.email.invalid, 'is-valid': loginFormSubmitted &&
                                !lf.email.invalid }" required>
                            <div *ngIf="loginFormSubmitted && (lf.email.invalid ||
                                lf.email.errors?.required)" class="help-block mt-1 text-danger"> <i
                                class="ft-alert-circle align-middle"></i> This is
                                required</div>
                            </div>
                            <div class="form-group">
                            <input type="password" formControlName="password" class="form-control" placeholder="Password"
                                [ngClass]="{ 'is-invalid': loginFormSubmitted &&
                                lf.password.invalid, 'is-valid': loginFormSubmitted &&
                                !lf.password.invalid }" required>
                            <div *ngIf="loginFormSubmitted && (lf.password.invalid ||
                                lf.password.errors?.required)" class="help-block mt-1 text-danger"> <i
                                class="ft-alert-circle align-middle"></i> This is
                                required
                            </div>
                            </div>
                            <div class="d-sm-flex justify-content-between mb-3
                            font-small-2">
                            <div class="remember-me mb-2 mb-sm-0">
                                <div class="checkbox auth-checkbox">
                                <input type="checkbox" formControlName="rememberMe" class="form-control" id="rememberMe">
                                <label for="rememberMe"><span class="font-small-2 mb-3
                                    font-weight-normal remember-btn">Remember Me</span></label>
                                </div>
                            </div>
                            <a class="forget-btn" [routerLink]="['/forgotpassword']">Forgot Password?</a>
                            </div>
                            <div class="d-flex justify-content-between flex-sm-row
                            flex-column slide-btns">
                            <!-- <a [routerLink]="['/connect-to-learn']" class="btn
                                bg-light-primary mb-2 mb-sm-0">Connect to Learn</a> -->
                            <button class="btn-size btn-bg-white rounded-bottom-right cursor-pointer" [disabled]="loginForm.invalid">Login</button>
                            </div>
                        </form>
                        <div class="d-flex justify-content-between align-items-center">
                            <ngx-spinner></ngx-spinner>
        </div>
                        <!-- <div class="d-flex justify-content-between align-items-center">
                            <h6 class="text-primary m-0">Or Login With</h6>
                            <ngx-spinner></ngx-spinner>
                            <div class="login-options">
                            <a class="btn btn-sm btn-social-icon btn-facebook mr-1"><span class="fa fa-facebook"></span></a>
                            <a class="btn btn-sm btn-social-icon btn-twitter mr-1"><span class="fa fa-twitter"></span></a>
                            </div>
                        </div> -->
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="carousel-content">
                            <h2><span class="font-weight-400">Welcome to</span><br> <span
                                    class="clr-pink"><b>Meander</b></span></h2>
                            <p>By empowering you and adjusting to your topic as well as technology, we hope to help you
                                to learn effectively with purpose. By enrolling, you may learn.</p>
                            <div class="slide-btns">
                                <div>
                                    <a class="btn-size btn-bg-white rounded-bottom-right"
                                        [routerLink]="'/connect-to-learn'">Connect To Learn</a>
                                </div>
                                <div>
                                    <!-- <a class="btn-size btn-bg-purple rounded-top-left" [routerLink]="'/login'">Login</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-item" style="background-image: url(assets/img/bgn-slide-02.jpg);">
                <div class="row m-0">
                    <div class="col-sm-12 col-md-6">
                        <div class="carousel-content align-right ml-auto">
                            <h2><span class="font-weight-400">College and</span><br><b class="clr-pink">Business
                                    Connect</b></h2>
                            <p>By enrolling in the Meander College Connect Programme, you will pave the route for your
                                professional development. It is time to invest in your future and start your journey
                                toward obtaining a great job. We are utilising this depth of experience to ensure that
                                the learning process connects to practical solutions.</p>
                            <div class="slide-btns justify-right">
                                <div>
                                    <a class="btn-size btn-bg-purple rounded-top-left"
                                        [routerLink]="'/connect-to-learn'">Connect To Learn</a>
                                </div>
                                <div>
                                    <!-- <a class="btn-size btn-bg-white rounded-bottom-right"
                                        [routerLink]="'/login'">Login</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 pr-0 login-page-box">
                        <!-- <img src="assets/img/img-slider-02.png" class="d-block w-100" alt="..."> -->
                  </div>
                </div>
            </div>

            <div class="carousel-item" style="background-image: url(assets/img/bgn-slide-01.jpg);">
                <div class="row mob-flex-direction m-0">
                    <div class="col-sm-12 col-md-6 pl-0 login-page-box">
                        <!-- <img src="assets/img/img-slider-03.png" class="d-block w-100" alt="..."> -->
                   </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="carousel-content">
                            <h2><span class="font-weight-400">Earn with us -</span><br> <span
                                    class="clr-pink"><b>Contact Us</b></span></h2>
                            <p>Whether you're starting a business or looking for your first job, we provide trusted
                                solutions that can help you to advance in the IT industry.</p>
                            <div class="slide-btns">
                                <div>
                                    <a class="btn-size btn-bg-white rounded-bottom-right"
                                        [routerLink]="'/connect-to-learn'">Connect To Learn</a>
                                </div>
                                <div>
                                    <!-- <a class="btn-size btn-bg-purple rounded-top-left" [routerLink]="'/login'">Login</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Slider First Section  -->

<!-- Start Second Section  -->
<div class="second-section-info bg-white-clr pt-3 pb-4">
    <div class="container">
        <div class="bt-bb-section bt-bb-layout-boxed-1200">
            <div class="row match-height">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card bg-blue-clr">
                        <div class="card-content">
                            <img src="assets/img/img-box-01.jpg" alt="Card image" class="img-fluid">
                            <div class="card-body mb-2">
                                <h3 class="card-title">Meander Training</h3>
                                <p class="card-text">We provide professional training and schooling for applicants who
                                    choose to research and develop their technical knowledge to enhance their employment
                                    opportunities.</p>
                                <div>
                                    <a class="btn-size btn-bg-white rounded-bottom-right"
                                        href="https://meander.training/">Find out more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card bg-pink-clr">
                        <div class="card-content">
                            <img src="assets/img/img-box-02.jpg" alt="Card image" class="img-fluid">
                            <div class="card-body mb-2">
                                <h3 class="card-title">Meander Software Mobile App Solution</h3>
                                <p class="card-text">Looking for any website or Mobile App solution, Let’s discuss the
                                    website and Mobile App Development services that we can offer to our clients.</p>
                                <div>
                                    <a class="btn-size btn-bg-white rounded-top-left"
                                        href="https://www.meander.software/">Find out more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card bg-purple-clr">
                        <div class="card-content">
                            <img src="assets/img/img-box-03.jpg" alt="Card image" class="img-fluid">
                            <div class="card-body mb-2">
                                <h3 class="card-title">Online eCommerce Solution</h3>
                                <p class="card-text">We will help you to build your eCommerce Solution for Business to
                                    Business and Business to Consumer with different technologies.</p>
                                <div>
                                    <a class="btn-size btn-bg-white rounded-bottom-right"
                                        href="https://www.meander.software/industries/retail-e-commerce/">Find out
                                        more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Third Section Technology for Innovators -->
<div class="bg-f5f5f5-clr" #works>
    <div class="third-section-info bg-white-clr pb-5">
        <div class="container pb-3">
            <div class="tech-innov-info">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="tech-innov-txt">
                            <h2 class="clr-pink">Technology <br> <span class="clr-blue">for Innovators</span></h2>
                            <p>Don’t just trust what we say. Take a look at our numbers.We want to provide you with the
                                best information possible, to help you make the best decision for your needs.That’s why
                                we provide you with statistics, information about customer service, and other details.
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-4">
                                <div class="counter-box-info">
                                    <div class="counter-number">
                                        <h3 class="clr-blue">90%</h3>
                                    </div>
                                    <div class="counter-txt">
                                        <p>Client Success</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-4">
                                <div class="counter-box-info">
                                    <div class="counter-number">
                                        <h3 class="clr-pink">500+</h3>
                                    </div>
                                    <div class="counter-txt">
                                        <p>Projects Done</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-4">
                                <div class="counter-box-info after-none">
                                    <div class="counter-number">
                                        <h3 class="clr-green">40+</h3>
                                    </div>
                                    <div class="counter-txt">
                                        <p>Achieved Awards</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tech-btn-info mt-4 mb-4">
                            <a class="btn-size btn-bg-blue rounded-top-left" href="#">Find out more</a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="technology-img-info">
                            <img src="assets/img/img-technology.png" alt="technology image" class="img-fluid">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Fourth Section Simple Solutions -->
<div class="fourth-section-info bg-f5f5f5-clr pt-5 pb-5" #program>
    <div class="container pt-3">
        <div class="simple-solutions-info">
            <div class="row pb-3">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <h2 class="clr-pink">Simple Solutions for <br> <span class="clr-blue">Complex Challenges</span></h2>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue1.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Strategy</h3>
                            <p>Credibly hold forth tremendously green synthetic merchandise and enabled data.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue2.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Teamwork</h3>
                            <p>Dramatically evisculate holistic innovation instead of consumer-centric data.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue3.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Cooperation</h3>
                            <p>Iterate aid maximising merchandise after modern highbrow capital.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue4.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Career Uprise</h3>
                            <p>Mesh low-threat excessive yield alignments earlier than obvious e-tailers.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue5.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Achieve Goals</h3>
                            <p>Implement visionary e-offerings vis-a-vis strategic web readiness.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue6.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Meet your Target</h3>
                            <p>Deliver overall performance primarily based totally on techniques while disbursed
                                empowerment expertise.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue7.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Be Creative</h3>
                            <p>Completely pursue scalable customer support through rough sustainable potentialities.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <div class="left-media-box">
                        <div class="media-box-info">
                            <img src="assets/img/icon-blue8.png" alt="icon image" class="img-fluid ml-min-35px">
                            <h3>Great Team</h3>
                            <p>Completely iterate covalent strategic topic regions thru correct e-marketplace solutions.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Five Section Software for Open Enterprise -->
<div class="bg-f5f5f5-clr" #projects>
    <div class="five-section-info software-section-info bg-white-clr pb-5">
        <div class="container pb-3">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="two-btn-info mt-min-30 mb-5 pb-4">
                        <a class="btn-size btn-bg-blue rounded-bottom-right" href="#">View more features</a>
                        <a class="btn-size btn-bg-purple rounded-top-left" href="#">Download app now</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-4">
                    <img src="assets/img/img-software.png" alt="Software image" class="img-fluid">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="software-content-info">
                        <h2 class="clr-pink">College Students Sense <br> <span class="clr-blue">Glad With Us</span></h2>
                        <p class="font-weight-500">Meander Training is a totally tremendous education corporation that
                            has quality approaches to beautify your abilities withinside the improvement sector. I
                            actually have finished my education in iOS and additionally, I am located in a very well
                            reputed organisation.</p>
                        <hr class="hr-line mt-4 mb-4" />
                        <!-- TESTIMONIALS -->
                        <div class="testimonials-info">
                            <div id="carousel-example-caption" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner" role="listbox">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12 mb-3">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Great And Well</h4>
                                                    <p>It has met my expectations in the manner in which the promise was
                                                        made. The service is straightforward and simple to use, along
                                                        with that all responses were polite and professional.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Priyanka Sharma</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Quite Professional</h4>
                                                    <p>Very professional job, excellent service, detailed information,
                                                        and timely response to inquiries. Meander software is
                                                        appreciated for assisting in the expansion of my brand.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Sagar Kumar</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12 mb-3">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Excellent Customer Service</h4>
                                                    <p>Excellent customer service throughout the entire process. The
                                                        entire staff has a strong background in technology and is
                                                        incredibly amiable and dependable, which has made the
                                                        development of my project so much simpler.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Shikha Thakur</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Appreciating Logical Skill</h4>
                                                    <p>Their product development demonstrates the calibre of a bigger
                                                        company. Obtain high-quality services with helpful customer
                                                        service and reasonable prices.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Eddie Brown</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12 mb-3">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Greatly Fixed Bug</h4>
                                                    <p>Any software organisation has recognised the value of flexibility
                                                        and the ability to modify logic. I was merely amused by how
                                                        easily they managed my bugs.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Varun Rana</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-sm-12">
                                                <div class="testimonials-content">
                                                    <h4 class="testi-title">Quite Professional</h4>
                                                    <p>Very professional job, excellent service, detailed information,
                                                        and timely response to inquiries. Meander software is
                                                        appreciated for assisting in the expansion of my brand.</p>
                                                    <div class="text-reviews">
                                                        <div class="reviews-star">
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                            <i class="ft-star-on"></i>
                                                        </div>
                                                        <h5 class="testi-name">Sagar Kumar</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="mb-3 mt-3">
                                        <a class="btn-size btn-bg-blue rounded-top-left" href="#">View all
                                            testimonials</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- END OF TESTIMONIALS -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Six Section logos -->
<div class="six-section-info bg-f5f5f5-clr pt-5 pb-5">
    <div class="container">
        <div class="logos-section-info">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active">
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-estato.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-bello.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-applauz.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-hotel-california.png" alt="logo image"
                                            class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-applauz.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-hotel-california.png" alt="logo image"
                                            class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-estato.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-bello.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="row">
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-hotel-california.png" alt="logo image"
                                            class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-avantage.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-estato.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-bello.png" alt="logo image" class="img-fluid">
                                    </div>
                                    <div class="col-6 col-sm-4 col-md-2">
                                        <img src="assets/img/logo-applauz.png" alt="logo image" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carousel-example-generic" role="button"
                            data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carousel-example-generic" role="button"
                            data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Seven Section Compare Meander Software -->
<div class="bg-white-clr">
    <div class="seven-section-info bg-blue-clr pt-5 pb-5">
        <div class="container">
            <div class="compare-codiqa-section-info pt-3 pb-3">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <h2 class="compare-h2"><span class="font-weight-400">Compare Meander Software</span><br><span
                                class="clr-pink">With others</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7 col-md-6 col-sm-12">
                        <div class="bt-bb-features-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Courses</th>
                                        <th>6 Weeks</th>
                                        <th>3 Months</th>
                                        <th>6 Months</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Python</td>
                                        <td><span class="bt_bb_features_table_no"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>MEAN</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>MERN</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Server Administration</td>
                                        <td><span class="bt_bb_features_table_no"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Designing</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Android</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>iOS</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>React Native</td>
                                        <td><span class="bt_bb_features_table_no"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Digital Marketing</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Testing - QA/QT</td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                        <td><span class="bt_bb_features_table_yes"></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-12">
                        <img src="assets/img/img-features.png" alt="features image" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Eight Section Great Software with Meander Software Team -->
<div class="bg-blue-clr">
    <div class="eight-section-info bg-white-clr pt-5 pb-5">
        <div class="container">
            <div class="software-team-section-info pt-4 pb-3">
                <div class="row mb-3">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <h2 class="clr-pink">Great Software<br><span class="clr-blue">with Meander Software Team</span>
                        </h2>
                        <p class="font-weight-500">Completely synergize useful resource taxing relationships through the
                            most desirable area of interest markets. Dynamically innovate useful resource-levelling
                            customer support for the kingdom of the artwork customer support.</p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <div class="card">
                            <div class="card-content">
                                <img src="assets/img/Sandeep.png" alt="Team image" class="img-fluid">
                                <div class="card-body">
                                    <p class="card-text clr-blue"><b class="clr-pink">Position:</b> Founder</p>
                                    <h3 class="card-title">Dr. Sandeep Srivastava</h3>
                                    <!-- <div>
                                        <a class="btn-size btn-bg-purple rounded-bottom-right" href="#">Read more</a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <div class="card">
                            <div class="card-content">
                                <img src="assets/img/Diwakar.png" alt="Team image" class="img-fluid">
                                <div class="card-body">
                                    <p class="card-text clr-blue"><b class="clr-pink">Position:</b> Co-Founder</p>
                                    <h3 class="card-title">Mr. Diwakar Tiwari</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                        <div class="card">
                            <div class="card-content">
                                <img src="assets/img/Kamlesh.png" alt="Team image" class="img-fluid">
                                <div class="card-body">
                                    <p class="card-text clr-blue"><b class="clr-pink">Position:</b> Professional Mentor
                                    </p>
                                    <h3 class="card-title">Mr. Kamlesh Yadav</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Nine Section Stay updated -->
<div class="nine-section-info bg-white-clr pt-4 pb-5">
    <div class="container">
        <div class="stay-updated-section-info">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="stay-update-img">
                        <img src="assets/img/img-newsletter.png" alt="newsletter image" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="stay-update-content">
                        <h2 class="clr-blue mb-2">Stay updated</h2>
                        <p class="font-weight-500">Keep up with Meander Software and get immediate information as soon
                            as possible. We promise no unsolicited mail or comparable emails, only natural goodness.</p>
                        <form>
                            <div class="newsletter-form-info mt-4">
                                <div class="email-field">
                                    <input type="email" name="your-email" class="wpcf7-email"
                                        placeholder="Enter your email address" required>
                                </div>
                                <div class="subscribe-button">
                                    <input type="submit" value="Subscribe" class="wpcf7-submit">
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Ten Section Would you like to join Meander Software App Team? -->
<div class="join-app-team-section-info bg-white-clr pt-2 pb-5">
    <div class="container">
        <div class="join-app-team-info pt-4 pb-3">
            <div class="row mb-3">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h2 class="clr-pink">Would you like to join<br><span class="clr-blue">Meander Software App
                            Team?</span></h2>
                    <p class="font-weight-500">Enthusiastically leverages present top class excellent vectors with
                        agency huge innovation. Phosfluorescently leverage others excessive effect answers outdoor the
                        container questioning with e-commercial enterprise ideas.</p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12"></div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <hr class="hr-line mt-1 mb-4">
                </div>
            </div>
            <div id="carousel" class="carousel slide mb-5" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#carousel" data-slide-to="0" class="active"></li>
                    <li data-target="#carousel" data-slide-to="1"></li>
                    <li data-target="#carousel" data-slide-to="2"></li>
                </ol>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="row">
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-blue1.png" alt="icon image" class="img-fluid">
                                        <h3>Challenging projects</h3>
                                        <p>Proactively envisioned multimedia expertise.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-21.png" alt="icon image" class="img-fluid">
                                        <h3>Custom working time</h3>
                                        <p>Utilizing enterprise via 24/7 markets.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-22.png" alt="icon image" class="img-fluid">
                                        <h3>Pixel perfect apps</h3>
                                        <p>Open-source via inexpensive materials.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-23.png" alt="icon image" class="img-fluid">
                                        <h3>Award winning team</h3>
                                        <p>Delivering performance based method.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="row">
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-24.png" alt="icon image" class="img-fluid">
                                        <h3>Award winning team</h3>
                                        <p>Delivering performance based method.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-25.png" alt="icon image" class="img-fluid">
                                        <h3>Creative environment</h3>
                                        <p>Global sources through interoperable services.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-27.png" alt="icon image" class="img-fluid">
                                        <h3>Challenging projects</h3>
                                        <p>Proactively envisioned multimedia expertise.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-26.png" alt="icon image" class="img-fluid">
                                        <h3>Awesome Achievements</h3>
                                        <p>Dramatically engage top-line web services.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="row">
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-22.png" alt="icon image" class="img-fluid">
                                        <h3>Pixel perfect apps</h3>
                                        <p>Open-source via inexpensive materials.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-23.png" alt="icon image" class="img-fluid">
                                        <h3>Award winning team</h3>
                                        <p>Delivering performance based method.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-21.png" alt="icon image" class="img-fluid">
                                        <h3>Custom working time</h3>
                                        <p>Utilizing enterprise via 24/7 markets.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3 col-lg-3">
                                <div class="left-media-box">
                                    <div class="media-box-info">
                                        <img src="assets/img/icon-blue1.png" alt="icon image" class="img-fluid">
                                        <h3>Challenging projects</h3>
                                        <p>Proactively envisioned multimedia expertise.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="two-btn-info mt-4 mb-3">
                        <a class="btn-size btn-bg-blue rounded-bottom-right" href="https://meander.training/">Contact us
                            anytime</a>
                        <a class="btn-size btn-bg-purple rounded-top-left" href="https://www.meander.software/">Apply
                            for open positions</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Footer Section -->
<footer class="bg-white-clr">
    <div class="footer-section-info bg-blue-clr pt-5 pb-4" style="background-image: url(assets/bgn-footer-bottom.png);">
        <div class="container mb-4">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="footer-col">
                        <div class="footer-logo-info">
                            <a href="https://www.meander.live/">
                                <img src="assets/logo-meander-white.png" alt="Logo" class="footer-image-logo">
                            </a>
                            <p>Directly contact us for one to one communication with our supportive team</p>
                        </div>
                        <ul class="footer-contact-link">
                            <li><a href="tel:+918090549054"><i class="ft-phone"></i> (+91)-80-9054-9054</a></li>
                            <li><a href="https://www.meander.software/"><i class="ft-globe"></i>
                                    www.meander.software</a></li>
                            <li><a href="mailto:hi@meander.software"><i class="ft-mail"></i> hi&#64;meander.software</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="footer-col">
                        <h3 class="footer-title">Applications</h3>
                        <ul class="footer-links">
                            <li><a href="#">Our Products</a></li>
                            <li><a href="#">News & Updates</a></li>
                            <li><a href="#">Features</a></li>
                            <li><a href="#">Pricelist</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="footer-col">
                        <h3 class="footer-title">Quick Link</h3>
                        <ul class="footer-links">
                            <li><a (click)="scroll(works)">How It Works</a></li>
                            <li><a (click)="scroll(program)">Program</a></li>
                            <li><a (click)="scroll(projects)">Projects</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="footer-col">
                        <h3 class="footer-title">Connect</h3>
                        <ul class="footer-social-links">
                            <li><a href="https://www.facebook.com/meandersoftware/" target="_blank"><i
                                        class="ft-facebook"></i></a></li>
                            <li><a href="https://twitter.com/meandersoftware" target="_blank"><i
                                        class="ft-twitter"></i></a></li>
                            <li><a href="https://in.linkedin.com/company/meandersoftware" target="_blank"><i
                                        class="ft-linkedin"></i></a></li>
                            <li><a href="https://www.instagram.com/accounts/login/?next=/meander.software/"
                                    target="_blank"><i class="ft-instagram"></i></a></li>
                        </ul>
                        <div class="sub-form-info">
                            <p>Keep up to date with latest news and update about Meander Software, simply subscribe with
                                your email address.</p>
                            <div class="newsletter-form-info pt-2">
                                <div class="input-group">
                                    <input type="text" placeholder="Email address" class="form-control">
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary"><i class="ft-send"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="footer-copyright-bar pt-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <p>Copyright © 2022 MEANDER SOFTWARE, All rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>